import { PreviewChannel, PreviewChannelsItem } from '../preview-channels-item';
import styles from './preview-channels-list.module.scss';

interface PreviewChannelsListProps {
  channels: PreviewChannel[];
}

export const PreviewChannelsList = ({ channels }: PreviewChannelsListProps) => {
  if (!channels.length) return null;

  return (
    <div className={styles.previewChannelsList}>
      {channels.map((channel) => (
        <PreviewChannelsItem key={channel.label} channel={channel} />
      ))}
    </div>
  );
};
